import React, { Component } from "react";
import { uploadToCloudinary } from "../../services/cloudinaryService";
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/Cancel';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import { addBrand, deleteBrand, xirifyEnv, updateBrand, brandList } from '../../actions/brandAction';
import { Badge, Divider } from "@material-ui/core";
import { CSVLink } from "react-csv";
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        width: '168px'
    },
    secondaryButton: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        border: '1px solid #14B7DD',
        fontWeight: 'bold'
    },
    closeBadge: {
        color: 'grey',
        cursor: 'pointer'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '400px'
    },
    deleteBtn: {
        cursor: 'pointer',
        color: 'grey',
        margin: "0px 10px"
    },
    editBtn: {
        cursor: 'pointer',
        color: 'grey',
        margin: "0px 10px"
    },
    avatarGrey: {
        width: theme.spacing(10),
        height: theme.spacing(6),
    },
    img: {
        width: '43px',
        height: '43px',
    },
    containerTable: {
        padding: '0px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        marginTop: theme.spacing(3)
    },
    table: {
        justifyContent: 'left'
    },
    tableRow: {
        cursor: 'pointer',
        height: '60px'
    },
    tableBtn: {
        padding: '0px'
    },
    form: {
        margin: '5% 10%',
        maxWidth: '350px',
        backgroundColor: theme.palette.background.paper,
    },
    headerBar: {
        color: 'white',
        backgroundColor: theme.palette.primary.main
    },
    headGridTwoButton: {
        float: 'right',
        marginTop: '2px'
    },
    content: {
        margin: '10px 0px',
        overflow: 'auto',
    },
    footer: {
        height: '10%',
        margin: '20px 0px 10px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class Brand extends Component {
    constructor() {
        super();
        this.state = {
            value: 0,
            modalAddOpen: false,
            modalEditOpen: false,
            modalDeleteOpen: false,
            snackOpen: false,
            noDelMsg: null,
            sucessMsg: null,
            showExcel: false,
            errorMsg: null,
            backDropOpen: false,
            isFetching: false,
            selectedBrand: null,
            brandExists: null,
            inputErrorMessage: null,
            cloudinaryData: null,
            brandName: "",
            brandImage: null,
            brandData: {},
            brandList: [],
            cloudinaryFileData: null,
            isDisabled: true,
            excelDownloadList: [],
            brandFile: null
        };
        this.inputReference = React.createRef();
    }

    fileUploadAction = () => this.inputReference.current.click();

    componentDidMount() {
        this.props.attrs.changeHeaderName("Brand");
        this.getBrandList();
        this.getCloudinaryEnv();
    }

    getBrandList = async () => {
        try {
            let response = await brandList();

            if (response && response.data) {
                this.setState({ brandList: response.data });

                let excelList = response.data.map(item => ({ name: item.name }));
                this.setState({ excelDownloadList: excelList });
            } else {
                console.error("Error: Unable to fetch brand list. Response or response data is undefined.");
            }
        } catch (error) {
            console.error("Error fetching brand list:", error);
        }
    }

    getCloudinaryEnv = async () => {
        try {
            let res = await xirifyEnv();
            if (res && res.data) {
                this.setState({ cloudinaryData: res.data });
            } else {
                console.error("Error: Unable to fetch cloudinary environment. Response or response data is undefined.");
            }
        } catch (error) {
            console.error("Error fetching cloudinary environment:", error);
        }
    }

    removeBrandImage = (e) => {
        this.setState({ brandFile: null });
    }

    handleChange = async (e) => {
        const { target: { value } } = e;
        if (e.target.files) {
            this.setState({ brandImage: e.target.files[0] });
            let files = e.target.files;
            let temp = files[0].name.split(".");
            let fileName = temp[0] + Math.ceil(Math.random() * 999999) + "." + temp[1];

            let file = await uploadToCloudinary(files[0], { publicId: fileName });
            this.setState({ brandFile: file });

        } else {
            this.setState({ brandName: value });
            if (!value.trim()) {
                this.setState({ inputErrorMessage: "Brand Name Cannot Be Empty" });
                this.setState({ brandName: "", isDisabled: true });
            } else {
                this.setState({ inputErrorMessage: null, isDisabled: false });
            }
        }
    }

    handleModalAddOpen = () => {
        this.setState({ modalAddOpen: true });
        this.setState({ brandName: "" })
        this.setState({ selectedBrand: null });
        this.setState({ brandImage: null, brandFile: null });
    }

    handleModalAddClose = () => {
        this.setState({ modalAddOpen: false, inputErrorMessage: null });
        this.setState({ brandImage: null, brandFile: null, brandName: '' });
    }

    handleDialogueDeleteOpen = (brandType) => {
        this.setState({ modalDeleteOpen: true });
        this.setState({ selectedBrand: brandType });
    }

    handleDialogueDeleteClose = () => {
        this.setState({ modalDeleteOpen: false });
    }

    handleEditModalOpen = (brandType) => {
        this.setState({ selectedBrand: { ...brandType } });
        this.setState({ brandName: brandType.name });
        this.setState({ brandImage: (brandType?.image?.path) ? brandType.image.path : null });
        if (brandType?.image?.path) {
            this.setState({ brandFile: { secure_url: brandType?.image?.path } });
        } else {
            this.setState({ brandFile: null });
        }
        this.setState({ modalEditOpen: true });
    }

    handleEditModalClose = () => {
        this.setState({ modalEditOpen: false });
        this.setState({ brandName: "" });
        this.setState({ brandImage: null, inputErrorMessage: null });
    }

    handleEditSubmit = async (event) => {
        event.preventDefault();

        if (!this.state.brandName) {
            this.setState({ errorMsg: "Brand Name Cannot Be Empty" });
            this.setState({ snackOpen: true });
            return;
        }

        let fileUpdated = false;
        if (this.state.brandFile && !this.state.brandFile.error) {
            fileUpdated = true;
        }

        if (!fileUpdated) {
            this.setState({ errorMsg: "Icon is mandatory" });
            this.setState({ snackOpen: true });
            return;
        }

        for (let i = 0; i < this.state.brandList.length; i++) {
            if (this.state.selectedBrand._id !== this.state.brandList[i]._id && this.state.brandName.trim().toLowerCase() === this.state.brandList[i].name.trim().toLowerCase()) {
                this.setState({ inputErrorMessage: "Brand With the Same Name Already Exists" });
                return;
            }
        }

        let payload = {
            _id: this.state.selectedBrand._id,
            name: this.state.brandName
        };

        if (fileUpdated) {
            payload["image"] = {
                title: "brand",
                path: this.state.brandFile.secure_url,
                public_id: this.state.brandFile.public_id
            }
        } else {
            payload.image = null;
        }

        let response = await updateBrand(payload);

        if (response) {
            this.setState({ sucessMsg: "Updated Brand Successfully" });
            this.setState({ modalEditOpen: false });
            this.getBrandList();
        } else {
            this.setState({ errorMsg: "Error in updating the Brand" });
            this.setState({ snackOpen: true });
        }
    }

    handleAddSubmit = async (event) => {
        event.preventDefault();

        this.setState({ isDisabled: true });
        if (!this.state.brandName) {
            this.setState({ errorMsg: "Brand Name Cannot Be Empty" });
            this.setState({ snackOpen: true });
            this.setState({ isDisabled: false });
            return;
        }

        if (!this.state.brandFile && !this.state.brandImage) {
            this.setState({ errorMsg: "Icon is mandatory" });
            this.setState({ snackOpen: true });
            this.setState({ isDisabled: false });
            return;
        }

        for (let i = 0; i < this.state.brandList.length; i++) {
            if (this.state.brandName.trim().toLowerCase() === this.state.brandList[i].name.trim().toLowerCase()) {
                this.setState({ inputErrorMessage: "Brand With the Same Name Already Exists" });
                return;
            }
        }

        let payload = {
            name: this.state.brandName
        };

        if (this.state.brandFile && !this.state.brandFile.error) {
            payload["image"] = {
                title: "Brand",
                path: this.state.brandFile.secure_url,
                public_id: this.state.brandFile.public_id
            }
        }

        let response = await addBrand(payload);

        if (response) {
            this.setState({ sucessMsg: "Added Brand Successfully" });
            this.setState({ modalAddOpen: false, brandName: '', brandFile: null });
            this.getBrandList();
        } else {
            this.setState({ errorMsg: "Error in Adding the Brand" });
            this.setState({ snackOpen: true });
        }
    }

    handleDeleteCategory = async () => {
        let response = await deleteBrand(this.state.selectedBrand._id);
        if (response) {
            this.setState({ modalDeleteOpen: false });
            this.getBrandList();
        }
    }

    handleSnackClose = () => {
        this.setState({ snackOpen: false });
        this.setState({ noDelMsg: null });
        this.setState({ errorMsg: null });
        this.setState({ sucessMsg: null });
    }

    showExcel = async () => {
        this.getBrandList();
        this.setState({ showExcel: true });
    }

    render() {
        const { classes } = this.props;
        let muiAlert = null;
        let headers = [
            { label: 'Brand Name', key: 'name' }
        ];

        if (this.state.sucessMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="success">
                {this.state.sucessMsg}
            </MuiAlert>
        } else if (this.state.errorMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.errorMsg}
            </MuiAlert>
        } else if (this.state.noDelMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.noDelMsg}
            </MuiAlert>
        } else if (this.state.brandExists) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.brandExists}
            </MuiAlert>
        }

        return (
            <Container>
                <Grid container justify="space-between">
                    <Grid item style={{ paddingRight: '460px' }}>
                        <Button variant="contained" color="primary" className={classes.button} startIcon={<AddIcon />}
                            onClick={this.handleModalAddOpen}>
                            BRAND
                        </Button>
                    </Grid>
                    <Grid alignContent="right" >
                        {this.state.showExcel ?
                            (this.state.excelDownloadList.length > 0 ?
                                <CSVLink
                                    data={this.state.excelDownloadList}
                                    headers={headers}
                                    filename={"brands.csv"}
                                    className="btn btn"
                                    target="_blank"
                                >
                                    <Tooltip title="Export to Excel">
                                        <img alt="Export To Excel" src="../../../images/exportToExcel.png" width="25" height="25" />
                                    </Tooltip>
                                </CSVLink>
                                : null)
                            :
                            <Button variant="contained" color="primary"
                                onClick={() => this.showExcel()}>
                                DOWNLOAD LIST
                            </Button>
                        }
                    </Grid>
                </Grid>
                {this.state.brandList.length > 0 &&
                    <Container className={classes.containerTable}>
                        <TableContainer className={classes.table} component={Paper}>
                            <Table size="small" aria-label="a dense table">
                                <TableBody>
                                    {this.state.brandList.map((brandType, index) => {
                                        return (
                                            <TableRow className={classes.tableRow} hover key={brandType.name}>
                                                <TableCell align="left" style={{ width: '100px' }}>
                                                    {brandType?.image?.path &&
                                                        <img style={{ "objectFit": "contain" }} variant="square" src={brandType?.image?.path} alt=" " className={classes.avatarGrey} />
                                                    }
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Typography color="textPrimary" variant="subtitle1" gutterBottom>
                                                        {brandType.name}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell align="right" className={classes.tableBtn} style={{ width: '100px' }}>
                                                    <div>
                                                        <EditIcon className={classes.editBtn} onClick={() => this.handleEditModalOpen(brandType)} />
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right" className={classes.tableBtn} style={{ width: '100px' }}>
                                                    <DeleteIcon className={classes.deleteBtn} onClick={() => this.handleDialogueDeleteOpen(brandType)} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                }
                <Dialog
                    className={classes.modal}
                    open={this.state.modalAddOpen}
                    onClose={this.handleModalAddClose}
                    closeAfterTransition
                    fullWidth={true}
                    maxWidth={false}
                >
                    <DialogTitle className={classes.headerBar} id="form-dialog-title">
                        <div >Add Brand
                            <CloseIcon className={classes.headGridTwoButton} onClick={this.handleModalAddClose} />
                        </div>
                    </DialogTitle>
                    <form className={classes.form} onSubmit={this.handleAddSubmit}>
                        <Grid container className={classes.content}>
                            <TextField
                                name="addBrand"
                                label="Brand Name"
                                value={this.state.brandName}
                                fullWidth variant="outlined"
                                margin="normal"
                                inputProps={{
                                    maxLength: 30,
                                }}
                                onChange={this.handleChange}
                                error={Boolean(this.state.inputErrorMessage)}
                                helperText={this.state.inputErrorMessage}
                            />

                            <Grid container style={{ margin: '20px 0px' }} alignItems="center" justify="space-around">
                                <Grid item xs={6} >
                                    {this.state.brandFile ?
                                        <Badge className={classes.closeBadge} badgeContent={<CancelIcon onClick={this.removeBrandImage} />}>
                                            <div className={classes.img}>
                                                <img border="0" className={classes.img} src={this.state.brandFile.secure_url} alt="" />
                                            </div >
                                        </Badge>
                                        :
                                        <div >
                                            <Typography >
                                                No File Chosen
                                            </Typography>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={6} >
                                    <Button variant="contained" htmlFor="myInput2" style={{ float: 'right' }} onClick={this.fileUploadAction} color="primary" className={classes.secondaryButton}>
                                        {this.state.brandFile ? 'Change Icon' : 'Add Icon'}
                                    </Button>
                                    <input
                                        ref={this.inputReference}
                                        id="myInput2"
                                        name="Brand"
                                        style={{ display: 'none' }}
                                        type={"file"}
                                        onChange={this.handleChange}
                                        accept="image/x-png,image/jpeg"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider></Divider>
                        <Container className={classes.footer}>
                            <div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    margin="normal"
                                    color="primary"
                                    disabled={this.state.isDisabled}
                                    onClick={this.handleAddSubmit}>
                                    Confirm
                                </Button>
                            </div>
                        </Container>
                    </form>
                </Dialog>
                <Dialog
                    className={classes.modal}
                    open={this.state.modalEditOpen}
                    onClose={this.handleEditModalClose}
                    closeAfterTransition
                    fullWidth={true}
                    maxWidth={false}
                >
                    <DialogTitle className={classes.headerBar} id="form-dialog-title">
                        <div >Edit Brand
                            <CloseIcon className={classes.headGridTwoButton} onClick={this.handleEditModalClose} />
                        </div>
                    </DialogTitle>
                    <form className={classes.form} onSubmit={this.handleEditSubmit}>
                        <Grid container className={classes.content}>
                            <TextField
                                name="editBrand"
                                label="Brand Name"
                                value={this.state.brandName}
                                fullWidth variant="outlined"
                                margin="normal"
                                inputProps={{
                                    maxLength: 30,
                                }}
                                onChange={this.handleChange}
                                error={Boolean(this.state.inputErrorMessage)}
                                helperText={this.state.inputErrorMessage}
                            />
                            <Grid container style={{ margin: '20px 0px' }} alignItems="center" justify="space-around">
                                <Grid item xs={6} >
                                    {this.state.brandFile ?
                                        <Badge className={classes.closeBadge} badgeContent={<CancelIcon onClick={this.removeBrandImage} />}>
                                            <div className={classes.img}>
                                                <img border="0" className={classes.img} src={this.state.brandFile.secure_url} alt="" />
                                            </div >
                                        </Badge>
                                        :
                                        <div >
                                            <Typography >
                                                No File Chosen
                                            </Typography>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={6} >
                                    <Button variant="contained" htmlFor="myInput2" style={{ float: 'right' }} onClick={this.fileUploadAction} color="primary" className={classes.secondaryButton}>
                                        {this.state.brandFile ? 'Change Icon' : 'Add Icon'}
                                    </Button>
                                    <input
                                        ref={this.inputReference}
                                        id="myInput2"
                                        name="Brand"
                                        style={{ display: 'none' }}
                                        type={"file"}
                                        onChange={this.handleChange}
                                        accept="image/x-png,image/jpeg"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider></Divider>
                        <Container className={classes.footer}>
                            <div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    margin="normal"
                                    color="primary"
                                    onClick={this.handleEditSubmit}>
                                    Confirm
                                </Button>
                            </div>
                        </Container>
                    </form>
                </Dialog>
                <Dialog
                    open={this.state.modalDeleteOpen}
                    onClose={this.handleDialogueDeleteClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Do you want to delete the brand?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={this.handleDialogueDeleteClose} className={classes.secondaryButton}>
                            No
                        </Button>
                        <Button variant="contained" onClick={this.handleDeleteCategory} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.snackOpen}
                    autoHideDuration={6000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}>
                    {muiAlert}
                </Snackbar>

            </Container >
        )
    }
}

export default (withStyles(styles)(Brand));

